module.exports = __webpack_public_path__ + "static/media/tachometer-alt-fast.23037ca9.svg";